module.exports = __webpack_public_path__ + "static/media/QarabaoHorizontalOrange.c72ff60d.png";